import Vue from 'vue'
import Router from 'vue-router'
import newsPublish from '@/pages/news_publish/news_publish'
import zhanlan from '@/pages/zhanlan/zhanlan'

Vue.use(Router)

export default new Router({
	mode: "history",
	routes: [{
			path: '/zhanlan',
			name: 'zhanlan',
			component: () =>
				import('@/pages/zhanlan/zhanlan'),
			meta: {
				nokeep: true
			}
		},{
			path: '/mwcs',
			name: 'mwcs',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/ias',
			name: 'ias',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/glcs',
			name: 'glcs',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/icts',
			name: 'icts',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/es',
			name: 'es',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/ftis',
			name: 'ftis',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/rs',
			name: 'rs',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/stis',
			name: 'stis',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/nmis',
			name: 'nmis',
			component: zhanlan,
			meta: {
				nokeep: true
			}
		},{
			path: '/match_apply',
			name: 'match_apply',
			component: () =>
				import('@/pages/match_apply/match_apply'),
			meta: {
				nokeep: true
			}
		},{
			path: '/icts_apply',
			name: 'icts_apply',
			component: () =>
				import('@/pages/match_apply/match_apply'),
			meta: {
				nokeep: true
			}
		},{
			path: '/es_apply',
			name: 'es_apply',
			component: () =>
				import('@/pages/match_apply/match_apply'),
			meta: {
				nokeep: true
			}
		},{
			path: '/search',
			name: 'search',
			component: () =>
				import('@/pages/search/search'),
			meta: {
				nokeep: false
			}
		},{
			path: '/data_down',
			name: 'data_down',
			component: () =>
				import('@/pages/data_down/data_down'),
			meta: {
				nokeep: true
			}
		},{
			path: '/team_enroll',
			name: 'team_enroll',
			component: () =>
				import('@/pages/login/team_enroll'),
			meta: {
				nokeep: true
			}
		},{
			path: '/login',
			name: 'login',
			component: () =>
				import('@/pages/login/login'),
			meta: {
				nokeep: true
			}
		},{
			path: '/match_process1',
			name: 'match_process1',
			component: () =>
				import('@/pages/match_process/match_process1'),
			meta: {
				nokeep: true
			}
		},{
			path: '/icon_down',
			name: 'icon_down',
			component: () =>
				import('@/pages/icon_down/icon_down'),
			meta: {
				nokeep: true
			}
		},{
			path: '/display_list',
			name: 'display_list',
			component: () =>
				import('@/pages/display_list/display_list'),
			meta: {
				nokeep: true
			}
		},{
			path: '/news_publish',
			name: 'news_publish',
			component: () =>
				import('@/pages/news_publish/news_page'),
			meta: {
				nokeep: false
			}
		},{
			path: '/news_page',
			name: 'news_page',
			component: () =>
				import('@/pages/news_publish/news_page'),
			meta: {
				nokeep: false
			}
		},{
			path: '/release_page',
			name: 'release_page',
			component: () =>
				import('@/pages/news_publish/release_page'),
			meta: {
				nokeep: false
			}
		},{
			path: '/events_page',
			name: 'events_page',
			component: () =>
				import('@/pages/news_publish/events_page'),
			meta: {
				nokeep: false
			}
		},{
			path: '/goodNews_page',
			name: 'goodNews_page',
			component: () =>
				import('@/pages/news_publish/goodNews_page'),
			meta: {
				nokeep: false
			}
		},{
			path: '/moreNews_page',
			name: 'moreNews_page',
			component: () =>
				import('@/pages/news_publish/moreNews_page'),
			meta: {
				nokeep: false
			}
		},{
			path: '/exhibitNews_page/:id',
			name: 'exhibitNews_page',
			component: () =>
				import('@/pages/news_publish/exhibitNews_page'),
			meta: {
				nokeep: false
			}
		},{
			path: '/forum',
			name: 'forum',
			component: () =>
				import('@/pages/forum/forum'),
			meta: {
				nokeep: true
			}
		},{
			path: '/match_process',
			name: 'match_process',
			component: () =>
				import('@/pages/match_process/match_process'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/home',
			name: 'home',
			component: () =>
				import('@/pages/home'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/en',
			name: 'en',
			component: () =>
				import('@/pages/home'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/mt1',
			name: 'mt1',
			component: () =>
				import('@/pages/home'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/mt2',
			name: 'mt2',
			component: () =>
				import('@/pages/home'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/mt3',
			name: 'mt3',
			component: () =>
				import('@/pages/home'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/mt4',
			name: 'mt4',
			component: () =>
				import('@/pages/home'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/mt5',
			name: 'mt5',
			component: () =>
				import('@/pages/home'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/system',
			name: 'system',
			component: () =>
				import('@/pages/system'),
			meta: {
				nokeep: false
			}
		},
		{
			path: '/register',
			name: 'register',
			component: () =>
				import('@/pages/register'),
			meta: {
				nokeep: false
			}
		},
		{
			path: '/registerEN',
			name: 'registerEN',
			component: () =>
				import('@/pages/register'),
			meta: {
				nokeep: false
			}
		},
		{
			path: '/',
			component: () =>
				import('@/pages/home'),
			meta: {
				nokeep: true
			}
		},
		{
			path: '/history',
			name: 'history',
			component: () =>
				import('@/pages/history'),
			meta: {
				nokeep: false
			}
		},
		{
			path: '/download_center',
			name: 'download_center',
			component: () =>
				import('@/pages/download_center'),
			meta: {
				nokeep: false
			}
		},
		{
			path: '/icon',
			name: 'icon',
			component: () =>
				import('@/pages/download_center'),
			meta: {
				nokeep: false
			}
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: () =>
				import('@/pages/contacts'),
			meta: {
				nokeep: false
			}
		},{
			path: '/live',
			name: 'live',
			component: () =>
				import('@/pages/live'),
			meta: {
				nokeep: true
			}
		},
	]
})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js